import React from 'react';
import { FlexibleImageDisplay } from './flexible-image-display';
import { StandardCropData } from '@/modules/uiImages/types';
import { UserIcon } from '@phosphor-icons/react';

interface AvatarImageProps {
  imageUrl?: string;
  imageCroppedUrl?: string;
  crop?: StandardCropData;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showFallback?: boolean;
  fallbackIcon?: React.ReactNode;
}

export function AvatarImage({
  imageUrl,
  imageCroppedUrl,
  crop,
  size = 'md',
  className = '',
  showFallback = true,
  fallbackIcon
}: AvatarImageProps) {
  const getFallbackIcon = () => {
    if (fallbackIcon) return fallbackIcon;
    return <UserIcon className="h-6 w-6 text-lureo-ink-subtlest" />;
  };

  return (
    <FlexibleImageDisplay
      imageUrl={imageUrl}
      imageCroppedUrl={imageCroppedUrl}
      crop={crop}
      imageCategory="Avatar"
      size={size}
      className={`${className} rounded-lureo-radius-avatar`}
      showCrop={true}
      fallbackIcon={showFallback ? getFallbackIcon() : undefined}
    />
  );
}
